import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthUtil } from '@app/common/util/auth.util';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate, CanActivateChild {

  constructor(private _router: Router) { }

  private readonly publicUrls: string[] = [
    '/login',
    '/about',
    '/servicePage/term-condition',
    '/servicePage/privacy-policy',
    '/business/member-registration-guide',
    '/login/forgot-id',
    '/login/forgot-passwd',
  ];

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    if (this.isPublicUrl(state.url)) {
      return true;
    }

    if (state.url.startsWith('/my-office/os.do') && route.queryParamMap.has('m')) {
      return true;
    }

    const isLogined = AuthUtil.isLogined();
    if (!isLogined) {
      return this._router.createUrlTree(['/login']);
    }

    return isLogined;
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }

  private isPublicUrl(url: string): boolean {
    const urlWithoutQuery = url.split('?')[0];
    return this.publicUrls.some(publicUrl => urlWithoutQuery === publicUrl || urlWithoutQuery.startsWith(publicUrl + '/'));
  }
}
